import React from "react";
// import CancellationRuleBuilderTabs from "./CancellationRuleBuilderTabs";
import Tabs from '../Tabs/Tabs';
import CancellationRuleBuilderTabContent from "./CancellationRuleBuilderTabContent";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CancellationRuleBuilderErrors from "./CancellationRuleBuilderErrors";

class CancellationRuleBuilder extends React.Component {

  constructor(props) {
    super(props)

    var billing_policies
    this.props.cancellation_rule.billing_policies && this.props.cancellation_rule.billing_policies.length > 0
      ? billing_policies = this.props.cancellation_rule.billing_policies.map(bp => bp.id)
      : billing_policies = []

    this.state = {
      active_tab: this.props.active_tab || 'general',
      tabs: true,
      name: this.props.cancellation_rule.name || '',
      code: this.props.cancellation_rule.code || '',
      amount: this.props.cancellation_rule.amount || '',
      days_charge: this.props.cancellation_rule.days_charge || '',
      custom_rule: this.props.cancellation_rule.custom_rule || '',
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      percentage: this.props.cancellation_rule.percentage || null,
      time_value: this.props.cancellation_rule.time_value != null ? this.props.cancellation_rule.time_value : "",
      taxes: this.props.cancellation_rule.taxes,
      fees: this.props.cancellation_rule.fees,
      loading: false,
      billing_policies: billing_policies,
      errors: this.props.errors || [],
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangePercentage = this.onChangePercentage.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeCode = this.onChangeCode.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeDaysCharge = this.onChangeDaysCharge.bind(this);
    this.onChangeCustomRule = this.onChangeCustomRule.bind(this);
    this.onChangeTimeValue = this.onChangeTimeValue.bind(this);
    this.onChangeTaxes = this.onChangeTaxes.bind(this);
    this.onChangeFees = this.onChangeFees.bind(this);
    this.onChangeBillingPolicies = this.onChangeBillingPolicies.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ]

    return (
        <div className="cancellation-rule-builder" ref="root">
        <Tabs tabs={this.tabs()} displayErrorMessage={(CancellationRuleBuilderErrors.general(this.state.errors).length || CancellationRuleBuilderErrors.billing_policies(this.state.errors).length ) ? true : false} />
          <div className="panel panel-form">
            {/* <CancellationRuleBuilderTabs {...this.state} onChangeActiveTab={this.onChangeActiveTab} /> */}
            <CancellationRuleBuilderTabContent {...this.state}
              all_taxes={this.props.all_taxes}
              all_fees={this.props.all_fees}
              all_billing_policies={this.props.all_billing_policies}
              dateFormat={this.props.date_format}
              onChangeName={this.onChangeName}
              onChangeCode={this.onChangeCode}
              onChangePercentage={this.onChangePercentage}
              onChangeAmount={this.onChangeAmount}
              onChangeDaysCharge={this.onChangeDaysCharge}
              onChangeCustomRule={this.onChangeCustomRule}
              onChangeTimeValue={this.onChangeTimeValue}
              onChangeTaxes={this.onChangeTaxes}
              onChangeFees={this.onChangeFees}
              onChangeBillingPolicies={this.onChangeBillingPolicies}
              />
          </div>
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <LoadingSpinner show={this.state.loading} />
        </div>
    );
  };

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: CancellationRuleBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('billing_policies'),
          targetName: 'billing_policies',
          classes: this.state.active_tab === 'billing_policies' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: CancellationRuleBuilderErrors.billing_policies(this.state.errors).length
        },
        // {
        //   tabName: I18n.t('taxes'),
        //   targetName: 'taxes',
        //   classes: this.state.active_tab === 'taxes' ? 'active' : null,
        //   changeHandler: this.onChangeActiveTab,
        // },
      ]
    );
  };

  prepParams() {
    var cancellationRule = Object.assign(this.props.cancellation_rule, {
      name: this.state.name,
      code: this.state.code,
      amount: this.state.amount,
      days_charge: this.state.days_charge,
      custom_rule: this.state.custom_rule,
      percentage: this.state.percentage,
      time_value: this.state.time_value,
      billing_policy_ids: this.state.billing_policies,
    })

    return cancellationRule
  }

  renderFieldClasses(field) {
    var classname = "form-control"
    if (this.state.errors && Object.keys(this.state.errors).length && this.state.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors[field]) {
      var idx = 0;
      var errors = this.state.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  /******************
  * Change handlers *
  *******************/

  onSave() {
    var self = this;
    this.setState({loading: true})
    var cancellationRule = this.prepParams()
    $.ajax({
      type: self.props.new_record ? 'POST' : 'PATCH',
      url: self.props.form_action,
      data: {
        cancellation_rule: cancellationRule,
        fee_ids: self.state.fees,
        tax_ids: self.state.taxes,
      }
    }).done((data) => {
      if (Object.keys(data.errors).length) {
        this.setState({
          loading: false,
          errors: data.errors
        })
      } else {
        window.parent.$(window.parent).trigger('cancellationRuleSaved', data);

        this.setState({loading: false});
        if (parent && parent.refresh_data) {
          if (self.props.new_record == true) {
            parent.refresh_data(I18n.t('cancellation_rule_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('cancellation_rule_saved_successfully'));
          }
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  }

  onChangeName(e) {
    this.setState({
      name: e.target.value,
    })
  }

  onChangeCode(e) {
    this.setState({
      code: e.target.value,
    })
  }

  onChangePercentage(value) {
   
      var state = this.state
      state.percentage = value
      state.amount = ""
      state.days_charge = ""
      state.custom_rule = ""
      this.setState(state)

  }

  onChangeAmount(value) {
    if (value) {
      var state = this.state
      state.amount = value
      state.percentage = null
      state.days_charge = ""
      state.custom_rule = ""
      this.setState(state)
    }
  }

  onChangeDaysCharge(e) {
    if (e) {
      var state = this.state
      state.days_charge = e.target.value
      state.percentage = null
      state.amount = ""
      state.custom_rule = ""
      this.setState(state)
    }
  }

  onChangeCustomRule(e){
    if (e) {
      var state = this.state
      state.custom_rule = e.target.value
      state.percentage = null
      state.amount = ""
      state.days_charge = ""
      this.setState(state)
    }
  }

  onChangeTimeValue(e) {
    this.setState({
      time_value: e.target.value
    })
  }

  onChangeTaxes(selected_taxes) {
    this.setState({
      taxes: selected_taxes
    })
  }

  onChangeFees(selected_fees) {
    this.setState({
      fees: selected_fees
    })
  }

  onChangeBillingPolicies(bp) {
    this.setState({
      billing_policies: bp,
    })
  }

}

export default CancellationRuleBuilder
